import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import RouteLayout from '../../RouteLayout'
import Spinner from '../../common/Spinner'
import { organizationList } from '../../../redux/reducers/organization-list-reducer'
import styles from './styles.module.css'

const ArrowIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
)

const getInitial = (name) => (name || '').trim().charAt(0)

const EduCommissions = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const auth = useSelector(state => state.auth.data)
  const { data: orgList, isLoading } = useSelector(state => state.reports.orgList)
  const orgListLength = orgList?.length || 0

  useEffect(() => {
    if (!orgListLength) {
      dispatch(organizationList.organizationListRequestStart(auth))
    }
  }, [dispatch, auth, orgListLength])

  const handleRowClick = (id) => {
    history.push(`/edu_commissions/${id}`)
  }

  return (
    <RouteLayout title={'Аттестационные комиссии ОО'}>
      {isLoading
        ? <Spinner />
        : (
          <div className={styles.orgList}>
            {orgList?.map((item) => (
              <div
                key={item.idOrganization}
                className={styles.orgCard}
                onClick={() => handleRowClick(item.idOrganization)}
              >
                <div className={styles.orgAvatar}>{getInitial(item.orgName)}</div>
                <div className={styles.orgName}>{item.orgName}</div>
                <div className={styles.orgArrow}><ArrowIcon /></div>
              </div>
            ))}
            {!orgList?.length && !isLoading && (
              <div className={styles.orgEmpty}>Список пуст</div>
            )}
          </div>
        )
      }
    </RouteLayout>
  )
}

export default EduCommissions
